import React from 'react';
import { Card, CardContent, Box, Skeleton } from '@mui/material';

interface SpeakerCardSkeletonProps {
  variant?: 'standard' | 'featured';
}

const SpeakerCardSkeleton: React.FC<SpeakerCardSkeletonProps> = ({ variant = 'standard' }) => {
  const isFeatured = variant === 'featured';

  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: isFeatured ? { xs: 'column', sm: 'row' } : 'column',
        bgcolor: '#222222',
        borderRadius: 4,
        overflow: 'hidden',
      }}
    >
      {/* Image placeholder */}
      <Box
        sx={{
          width: isFeatured ? { xs: '100%', sm: '40%' } : '100%',
          height: isFeatured ? { xs: 250, sm: '100%' } : 300,
          flexShrink: 0,
        }}
      >
        <Skeleton variant="rectangular" width="100%" height="100%" sx={{ bgcolor: 'rgba(255,255,255,0.08)' }} />
      </Box>

      <CardContent
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          width: isFeatured ? { xs: '100%', sm: '60%' } : '100%',
          p: isFeatured ? { xs: 2, sm: 3 } : 2,
        }}
      >
        {/* Name */}
        <Skeleton variant="text" width={isFeatured ? '60%' : '70%'} height={isFeatured ? 36 : 30} sx={{ bgcolor: 'rgba(255,255,255,0.12)', mb: 1 }} />
        {/* Company */}
        <Skeleton variant="text" width={isFeatured ? '40%' : '50%'} height={isFeatured ? 28 : 24} sx={{ bgcolor: 'rgba(255,255,255,0.12)', mb: 2 }} />
        {/* Tag */}
        <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
          <Skeleton variant="rounded" width={100} height={28} sx={{ bgcolor: 'rgba(255,255,255,0.12)' }} />
        </Box>
        {/* Excerpt lines */}
        <Skeleton variant="text" width="100%" height={20} sx={{ bgcolor: 'rgba(255,255,255,0.1)', mb: 1 }} />
        <Skeleton variant="text" width="85%" height={20} sx={{ bgcolor: 'rgba(255,255,255,0.1)' }} />
      </CardContent>
    </Card>
  );
};

export default SpeakerCardSkeleton; 